<div>
  <div class="text-night-darker strong mb-1 flex items-center gap-1">
    <div class="w-full">Guest portal</div>
    <sbnb-copy-to-clipboard [content]="guestPortalUrl" tooltipText="Copy guest portal link"></sbnb-copy-to-clipboard>
  </div>

  <div class="text-night-lighter text-sm">Collect guest info ahead of check-in.</div>
</div>
